import {Directive, HostListener} from "@angular/core";
    
@Directive({
    selector: "[mousedown-stop-propagation]"
})
export class MousedownStopPropagation
{
    @HostListener("mousedown", ["$event"])
    public onClick(event: any): void
    {
        event.stopPropagation();
    }
}